export default function collection(items, model) {
    return items.map((item) => {return model.create(item)});
}